import { QueueService } from "./queueService";

export default new QueueService();
